module.exports = __webpack_public_path__ + "static/media/MovingApp_android_2_preview.798ab8a0.jpg";